module.exports = __webpack_public_path__ + "img/circular.144c83ee.png";